var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 16,
    fill: "#E0F3F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1996 27.5994V31.7994H33.8996L28.2506 29.3214L25.4996 37.5744V56.9994H17.0996V35.9994L20.4176 26.2764C21.2156 23.9244 23.8616 22.7484 26.1296 23.7774L34.8446 27.6204L40.1996 27.5994ZM27.5996 12.8994C25.2896 12.8994 23.3996 14.7894 23.3996 17.0994C23.3996 19.4094 25.2896 21.2994 27.5996 21.2994C29.9096 21.2994 31.7996 19.4094 31.7996 17.0994C31.7996 14.7894 29.9096 12.8994 27.5996 12.8994ZM29.6996 50.6994H54.8996V46.4994H29.6996V50.6994ZM51.7496 44.3994C53.4926 44.3994 54.8996 42.9924 54.8996 41.2494C54.8996 39.5064 53.4926 38.0994 51.7496 38.0994C50.0066 38.0994 48.5996 39.5064 48.5996 41.2494C48.5996 42.9924 50.0066 44.3994 51.7496 44.3994ZM38.0996 35.9994C38.0996 34.8444 37.1546 33.8994 35.9996 33.8994H29.6996V38.0994H33.8996V40.1994C33.8996 42.5094 35.7896 44.3994 38.0996 44.3994H42.2996C44.6096 44.3994 46.4996 42.5094 46.4996 40.1994V33.8994H42.2996V38.0994H38.0996V35.9994Z",
    fill: "#1A9CC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBath);
export default __webpack_public_path__ + "static/media/bath.eae09371b3a006a82c9e477d8475e025.svg";
export { ForwardRef as ReactComponent };